module.exports = __webpack_public_path__ + "static/img/jigou-xibu-bottom.d02f576.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-xibu-bottom.png
// module id = 6Hih
// module chunks = 1